import {
  ThemeProvider,
  CssBaseline,
  Container,
  Box,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import theme from "./theme";
import {
  BrowserRouter,
  Outlet,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Certificates from "./pages/Certificates";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ContentEditor from "./pages/admin/ContentEditor";
import ProductsAdmin from "./pages/admin/ProductsAdmin";
import CategoriesAdmin from "./pages/admin/CategoriesAdmin";
import CertificatesAdmin from "./pages/admin/CertificatesAdmin";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import StickyContact from "./components/ui/StickyContact";
import CompanyAdmin from "./pages/admin/CompanyAdmin";
import AboutAdmin from "./pages/admin/AboutAdmin";
import ContactAdmin from "./pages/admin/ContactAdmin";
import AttributesAdmin from "./pages/admin/AttributesAdmin";
import MigrationAdmin from "./pages/admin/MigrationAdmin";
import ReferencesAdmin from "./pages/admin/ReferencesAdmin";
import ProductEditor from "./pages/admin/ProductEditor";
import AdminLayout from "./components/admin/AdminLayout";

// removed unused HomeHero

function Layout() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navbar />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>
      <Footer />
      <StickyContact />
    </Box>
  );
}

// Admin sayfaları için ayrı layout wrapper
function AdminLayoutWrapper() {
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}

function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    // Scroll window to top on route change
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      // Fallbacks for older browsers/mobile
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }, [pathname, search]);
  return null;
}

function Page({ title }: { title: string }) {
  return (
    <Container sx={{ py: 6 }}>
      <Typography variant="h3" sx={{ fontWeight: 700, mb: 2 }}>
        {title}
      </Typography>
      <Typography color="text.secondary">İçerik yakında.</Typography>
    </Container>
  );
}

export default function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Admin Login - Layout olmadan */}
            <Route path="/admin/login" element={<AdminLogin />} />

            {/* Admin sayfaları - AdminLayout ile */}
            <Route path="/admin" element={<AdminLayoutWrapper />}>
              <Route index element={<AdminDashboard />} />
              <Route path="content" element={<ContentEditor />} />
              <Route path="products" element={<ProductsAdmin />} />
              <Route path="products/new" element={<ProductEditor />} />
              <Route path="products/:slug/edit" element={<ProductEditor />} />
              <Route path="categories" element={<CategoriesAdmin />} />
              <Route path="certificates" element={<CertificatesAdmin />} />
              <Route path="company" element={<CompanyAdmin />} />
              <Route path="attributes" element={<AttributesAdmin />} />
              <Route path="migration" element={<MigrationAdmin />} />
              <Route path="references" element={<ReferencesAdmin />} />
              <Route path="about" element={<AboutAdmin />} />
              <Route path="contact-page" element={<ContactAdmin />} />
              <Route path="*" element={<Page title="Sayfa bulunamadı" />} />
            </Route>

            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="products" element={<Products />} />
              <Route path="products/:slug" element={<ProductDetail />} />
              <Route path="certificates" element={<Certificates />} />
              <Route path="about" element={<About />} />
              <Route path="contact" element={<Contact />} />
              <Route path="*" element={<Page title="Sayfa bulunamadı" />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </I18nextProvider>
  );
}
